import React from "react";
import styled from "styled-components";

const TwoFADisabledIcon = ({ className }: { className?: string }) => {
  return (
    <svg
      className={className}
      width="14px"
      height="16px"
      viewBox="0 0 14 16"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <defs>
        <path
          d="M13,16 C14.109375,16 15,15.1015625 15,14 L15,8 C15,6.8984375 14.109375,6 13,6 L6,6 L6,4 C6,2.8984375 6.8984375,2 8,2 C9.1015625,2 10,2.8984375 10,4 L12,4 C12,1.7890625 10.2109375,0 8,0 C5.7890625,0 4,1.7890625 4,4 L4,6 L3,6 C1.8984375,6 1,6.8984375 1,8 L1,14 C1,15.1015625 1.8984375,16 3,16 L13,16 Z"
          id="path-1"
        ></path>
      </defs>
      <g id="Platform-Settings" stroke="none" fill="none">
        <g
          id="Settings-Security-2FA-Disabled"
          transform="translate(-422.000000, -233.000000)"
        >
          <g id="Security" transform="translate(216.000000, 154.000000)">
            <g
              id="Two-factor-authentication"
              transform="translate(24.000000, 67.000000)"
            >
              <g id="icons/lock" transform="translate(181.000000, 12.000000)">
                <mask id="mask-2" fill="white">
                  <use xlinkHref="#path-1"></use>
                </mask>
                <use
                  id="Lock-Unlocked"
                  fill="#231F20"
                  xlinkHref="#path-1"
                ></use>
                <g id="Group" mask="url(#mask-2)" fill="#E64632">
                  <g id="fill/dark">
                    <rect id="box" x="0" y="0" width="16" height="16"></rect>
                  </g>
                </g>
                <path
                  d="M5.45008009,13.2506674 L2.05125467,13.2506674 L2.05125467,12.417779 L3.19487453,11.2613454 C3.5216247,10.9196459 3.73518369,10.6863327 3.83555793,10.5613988 C3.93593216,10.4364649 4.00587273,10.3291515 4.04538174,10.2394554 C4.08489075,10.1497593 4.10464495,10.0557933 4.10464495,9.95755473 C4.10464495,9.83582427 4.06513654,9.73972272 3.98611853,9.6692472 C3.90710051,9.59877167 3.79604983,9.56353444 3.65296316,9.56353444 C3.50560524,9.56353444 3.35664784,9.60571234 3.20608649,9.69006941 C3.05552514,9.77442648 2.88521184,9.89882459 2.69514148,10.0632675 L2,9.24959957 C2.24132529,9.03390175 2.44420633,8.87960538 2.60864923,8.78670582 C2.77309212,8.69380626 2.95194778,8.6227979 3.14522157,8.57367859 C3.33849536,8.52455928 3.55579164,8.5 3.79711692,8.5 C4.10037525,8.5 4.37106128,8.55338975 4.60918313,8.66017085 C4.84730498,8.76695195 5.03203351,8.91911273 5.16337427,9.11665777 C5.29471502,9.3142028 5.36038441,9.53577026 5.36038441,9.78136679 C5.36038441,9.96503028 5.33742682,10.1348097 5.29151095,10.2907101 C5.24559507,10.4466105 5.17458671,10.5998391 5.07848372,10.7504004 C4.98238073,10.9009618 4.85477923,11.0595293 4.69567539,11.2261078 C4.53657155,11.3926864 4.19754664,11.7087537 3.6785905,12.1743193 L3.6785905,12.2063534 L5.45008009,12.2063534 L5.45008009,13.2506674 Z M7.4522157,13.2506674 L6.20608649,13.2506674 L6.20608649,8.56727176 L8.97383876,8.56727176 L8.97383876,9.58275494 L7.4522157,9.58275494 L7.4522157,10.4765083 L8.85531233,10.4765083 L8.85531233,11.4919915 L7.4522157,11.4919915 L7.4522157,13.2506674 Z M12.6161239,13.2506674 L12.3854778,12.3729311 L10.8638548,12.3729311 L10.6268019,13.2506674 L9.23651895,13.2506674 L10.7645489,8.54805125 L12.4527496,8.54805125 L14,13.2506674 L12.6161239,13.2506674 Z M12.1227977,11.335024 L11.9209824,10.566204 C11.8739987,10.3953542 11.8168717,10.1743206 11.7495996,9.90309664 C11.6823275,9.63187264 11.638014,9.43753396 11.6166578,9.32007475 C11.5974372,9.42899147 11.5595304,9.60838103 11.5029365,9.8582488 C11.4463425,10.1081166 11.3208766,10.6003701 11.126535,11.335024 L12.1227977,11.335024 Z"
                  id="2FA"
                  fill="#FFFFFF"
                  mask="url(#mask-2)"
                ></path>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};

export default styled(TwoFADisabledIcon)`
  position: relative;
  bottom: 3px;
  margin: 0 5px;
`;
